import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckoutForm } from '@/components/billing/checkout-form';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function CheckoutPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const planId = searchParams.get('planId');
  const subscriptionId = searchParams.get('subscriptionId');

  const handleSuccess = () => {
    setTimeout(() => {
      navigate('/billing');
    }, 2000);
  };

  const handleCancel = () => {
    navigate('/billing');
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <Button
        variant="ghost"
        onClick={() => navigate(-1)}
        className="mb-6"
      >
        <ArrowLeft className="h-4 w-4 mr-2" />
        {t('checkout.back')}
      </Button>

      <CheckoutForm 
        planId={planId}
        subscriptionId={subscriptionId}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
}
